<template>
    <div class="flex truncate" v-bind="$attrs" v-on="$listeners">
        <vx-basic-icon
            v-if="!hideIcon"
            class="mr-3"
            :icon="mobile ? 'SmartphoneIcon' : 'PhoneIcon'"
        />
        <template v-if="hasPhone && isValid">
            <span v-if="noLink">
                {{ parsedPhone | VMask(mask) }}
            </span>
            <a v-else :href="`tel:${parsedPhone}`">
                {{ parsedPhone | VMask(mask) }}
            </a>
        </template>
        <span v-else class="disabled" :class="{ 'text-danger': !isValid }">
            {{ parsedPhone }}
            <span v-if="!isValid">*</span>
        </span>
    </div>
</template>

<script>
import { VueMaskFilter } from 'v-mask'
const PHONE_REGEX =
    /\({0,1}((0|\+61)(\s+)?(2|4|3|7|8)){0,1}\){0,1}( |-|.){0,1}[0-9]{2}( |-|.){0,1}[0-9]{2}( |-|.){0,1}[0-9]{1}( |-|.){0,1}[0-9]{3}/

export default {
    name: 'vx-phone',
    filters: {
        VMask: VueMaskFilter
    },
    props: {
        value: {
            type: String
        },
        hideIcon: {
            type: Boolean,
            default: false
        },
        mobile: {
            type: Boolean,
            default: false
        },
        noLink: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        trimmedPhone() {
            return (this.value || '').replace(/[^\d+()]/g, '')
        },
        isMobile() {
            if (!this.hasPhone) {
                return false
            }
            if (this.mobile) {
                return true
            }
            return (
                this.trimmedPhone.startsWith('04') ||
                this.trimmedPhone.startsWith('+614') ||
                this.trimmedPhone.startsWith('+6104')
            )
        },
        hasPhone() {
            return !!this.trimmedPhone
        },
        parsedPhone() {
            if (this.hasPhone) {
                return this.trimmedPhone
            } else {
                return `No ${this.mobile ? 'mobile' : 'phone'}`
            }
        },
        isValid() {
            return PHONE_REGEX.test(this.parsedPhone)
        },
        mask() {
            if (!this.trimmedPhone) {
                if (this.mobile) {
                    return '#### ### ###'
                } else {
                    return '(##) #### ####'
                }
            }

            if (this.trimmedPhone.length >= 3) {
                // Australian mobile number
                if (this.trimmedPhone.startsWith('04')) {
                    return '#### ### ###'
                }

                // International code is set
                if (this.trimmedPhone.startsWith('+')) {
                    if (this.trimmedPhone.startsWith('+61')) {
                        if (this.mobile) {
                            return '+## ### ### ###'
                        }
                        return '+### #### ####'
                    } else if (this.trimmedPhone.startsWith('+1')) {
                        return '+#-###-###-####'
                    } else if (this.trimmedPhone.startsWith('+7')) {
                        return '+#-###-###-##-##'
                    } else if (this.trimmedPhone.startsWith('+44')) {
                        return '+## #### ######'
                    }
                    return '+XXXXXXXXXXXXXX'
                }

                if (this.trimmedPhone.startsWith('0') || this.trimmedPhone.startsWith('(')) {
                    return '(##) #### ####'
                } else if (this.trimmedPhone.length < 9) {
                    return '#### ####'
                }
            }
            return 'XXXXXXXXXXXXXXX'
        }
    }
}
</script>

<style></style>
